import * as Sentry from "@sentry/react";

import parseActiveExperts from "../../parseActiveExperts";
import {
  BUILDING_ACTIVE_EXPERTS_QUERY,
  SALE_ACTIVE_EXPERTS_QUERY
} from "../../queries";
import useAgentData from "../useAgentData";
import useFeatureState from "../useFeatureState";

const captureException = message => Sentry.captureException(new Error(message));

const useActiveExperts = () => {
  const localData = useFeatureState();
  const { buildingId, expertContactIds, listingId, segmentName } = localData;
  const segmentInput = {
    building_id: buildingId,
    listing_id: listingId,
    segment_name: segmentName
  };

  const variables = {
    building_id: buildingId,
    contact_ids_input: { contact_ids: expertContactIds },
    segment_input: segmentInput,
    ...(listingId && { sale_id: listingId })
  };

  const queryExperts = listingId || buildingId;

  const QUERY = listingId
    ? SALE_ACTIVE_EXPERTS_QUERY
    : BUILDING_ACTIVE_EXPERTS_QUERY;

  const shouldQueryExperts = Boolean(queryExperts);
  const queryParams = {
    fetchPolicy: !shouldQueryExperts ? "cache-only" : "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !shouldQueryExperts,
    variables
  };

  const agentData = useAgentData(QUERY, queryParams);
  const parsedData = parseActiveExperts(agentData);

  if (queryExperts && !agentData?.loading && !parsedData?.expert) {
    Sentry.withScope(scope => {
      scope.setTags({
        contact_box: "experts",
        feature: "experts-contact-box",
        ...segmentInput
      });
      scope.setExtras({
        data_from_gql: JSON.stringify(agentData?.data ?? {}),
        error_from_gql: JSON.stringify(agentData?.error ?? {}),
        gql_query: QUERY.loc.source.body,
        gql_query_variables: JSON.stringify(variables),
        local_data: JSON.stringify(localData)
      });

      // send error to sentry
      if (agentData?.error?.graphQLErrors?.length) {
        // eslint-disable-next-line no-unused-expressions
        agentData.error.graphQLErrors.forEach(err => {
          Sentry.captureException(err);
        });
      } else if (agentData?.error?.message) {
        captureException(agentData.error.message);
      } else {
        captureException(
          `No experts exist for this ${listingId ? "listing" : "building"}`
        );
      }
    });
  }

  return parsedData;
};

export default useActiveExperts;
